import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { Work } from "@/components/site/Work";
import { Transformation } from "@/components/site/Transformation";
import { CtaBand } from "@/components/site/CtaBand";

export default function WorksPage() {
    return (
        <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Seo
                title="Radovi | Ramljak Auto Detailing Centar Ljubuški"
                siteName="Ramljak Auto Detailing Centar"
                description="Galerija radova Ramljak Auto Detailing Centra — detaljirana vozila, prije/poslije usporedbe i završni sjaj."
            />
            <div className="pt-20 md:pt-24">
                <Work />
            </div>
            <Transformation />
            <CtaBand />
        </motion.main>
    );
}
